import axios from "utils/APIv2";

export const arForecastModelTrigger = async () => {
  return await axios.post(`/model-trigger/AR-Forecast`);
};
export const getForecastDate = async () => {
  const res = await axios.get(`/app`);
  return res.data;
};
